module.exports = __webpack_public_path__ + "assets/images/Order_Type_R_Icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Order_Type_R_Icon.png
// module id = 1426
// module chunks = 1